export default __webpack_public_path__ + "static/media/Shaka_particle_final_06.74a0de2b.png";